// src/components/Footer.js
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LangContext } from "../lang/LangProvider";
import { showOCFData, SERVICE_ACTIVE, getRegistration, getServiceStatusNotice } from "../config/compliance";
import "./Footer.css";

export default function Footer() {
  const { lang } = useContext(LangContext);
  const currentYear = new Date().getFullYear();

  // Revisione 29/09/2026: iscrizione riferita al titolare (persona fisica), non al marchio;
  // niente "CFA" isolato; avviso esatto sullo stato del servizio nella fascia in basso.
  const footerTexts = {
    it: {
      company: "AlphaFrame Analytics",
      registration: getRegistration("it"),
      email: "alphaframeanalytics.it@gmail.com",
      legal: "Note Legali",
      privacy: "Privacy Policy",
      terms: "Termini di utilizzo",
      transparency: "Trasparenza",
      copyright: "Tutti i diritti riservati.",
      disclaimer: "Il sito contiene contenuti informativi ed educativi e strumenti di simulazione, che non costituiscono consulenza in materia di investimenti, raccomandazioni personalizzate, offerta o sollecitazione. Alcune comunicazioni hanno natura promozionale. I rendimenti passati o simulati non sono indicativi di quelli futuri; ogni investimento comporta rischi, inclusa la possibile perdita del capitale.",
      socialLabel: "Social Media",
    },
    en: {
      company: "AlphaFrame Analytics",
      registration: getRegistration("en"),
      email: "alphaframeanalytics.it@gmail.com",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Use",
      transparency: "Transparency",
      copyright: "All rights reserved.",
      disclaimer: "This website contains informational and educational content and simulation tools, which do not constitute investment advice, personalised recommendations, an offer or a solicitation. Some communications are of a promotional nature. Past or simulated returns are not indicative of future ones; every investment involves risks, including the possible loss of capital.",
      socialLabel: "Social Media",
    },
  };

  const texts = lang === "en" ? footerTexts.en : footerTexts.it;
  const notice = getServiceStatusNotice(lang);

  return (
    <footer className="af-footer" role="contentinfo">
      <div className="af-footer-container">
        {/* Section 1: sito e iscrizione del titolare */}
        <div className="af-footer-section">
          <h3 className="af-footer-title">{texts.company}</h3>
          {showOCFData && (
            <p className="af-footer-cfa-info">{texts.registration}</p>
          )}
          <p className="af-footer-contact">
            Email:{" "}
            <a href="mailto:alphaframeanalytics.it@gmail.com" className="af-footer-link">
              {texts.email}
            </a>
          </p>
        </div>

        {/* Section 2: Legal Links */}
        <div className="af-footer-section">
          <h4 className="af-footer-subtitle">{texts.legal}</h4>
          <ul className="af-footer-list">
            <li>
              <Link to={`/${lang}/privacy`} className="af-footer-link">
                {texts.privacy}
              </Link>
            </li>
            <li>
              <Link to={`/${lang}/terms`} className="af-footer-link">
                {texts.terms}
              </Link>
            </li>
            <li>
              <Link to={`/${lang}/transparency`} className="af-footer-link">
                {texts.transparency}
              </Link>
            </li>
          </ul>
        </div>

        {/* Section 3: Social & Quick Links */}
        <div className="af-footer-section">
          <h4 className="af-footer-subtitle">{texts.socialLabel}</h4>
          <ul className="af-footer-list">
            <li>
              <a
                href="https://www.youtube.com/channel/UCRr6dSJE95B8z-czPW-aq_Q"
                target="_blank"
                rel="noopener noreferrer"
                className="af-footer-link"
              >
                YouTube
              </a>
            </li>
            <li>
              <a
                href="mailto:alphaframeanalytics.it@gmail.com"
                className="af-footer-link"
              >
                {lang === "it" ? "Contatti" : "Contact"}
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Disclaimer & Copyright */}
      <div className="af-footer-bottom">
        {/* Avviso esatto sullo stato del servizio: presente in tutte le pagine tramite il footer */}
        {!SERVICE_ACTIVE && (
          <p className="af-footer-disclaimer">
            <small>
              <strong>{notice.title}.</strong> {notice.paras.join(" ")}{" "}
              <Link to={`/${lang}/transparency#stato-servizio`} className="af-footer-link">
                {texts.transparency} →
              </Link>
            </small>
          </p>
        )}
        <p className="af-footer-disclaimer">
          <small>{texts.disclaimer}</small>
        </p>
        <p className="af-footer-copyright">
          <small>
            &copy; {currentYear} AlphaFrame Analytics. {texts.copyright}
          </small>
        </p>
      </div>
    </footer>
  );
}
